import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function FacebookIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M15.1023 12.1609L15.5517 9.21349H12.7407V7.3008C12.7407 6.49443 13.1334 5.70845 14.3924 5.70845H15.6705V3.19915C15.6705 3.19915 14.5106 3 13.4017 3C11.0866 3 9.57342 4.41158 9.57342 6.96708V9.21349H7V12.1609H9.57342V19.2861C10.0894 19.3675 10.6183 19.41 11.1571 19.41C11.6958 19.41 12.2247 19.3675 12.7407 19.2861V12.1609H15.1023Z" fill="currentColor"/>
    </SvgIcon>
  );
}
